import React, { useEffect, useState } from 'react'
import FetchApi, { host } from '../../customhooks/functionFetchApi';
import Tablecolordetail from './tablecolordetail';
import { CiImageOn } from "react-icons/ci";
import { FaFileDownload } from "react-icons/fa";
import ViewImages from '../../form01/components/viewImages';
import Viewnewcolerprinting from './viewnewcolerprinting';

// import { styles } from "../../css/style";
const colorheader = {
    number: 0,
    colorheader: "",
    detailcolor: [],
    remark: ""
}

const ViewColorlist = ({ journalId }) => {

    const FetchApis = new FetchApi();

    const [JourColorHeader, setJourColorHeader] = useState([])
    const [jouranlheader, setJournalhead] = useState([])
    // detail ink
    const [colorlist1, setColorlist1] = useState(colorheader);
    const [colorlist2, setColorlist2] = useState(colorheader);
    const [colorlist3, setColorlist3] = useState(colorheader);
    const [colorlist4, setColorlist4] = useState(colorheader);
    const [colorlist5, setColorlist5] = useState(colorheader);
    const [colorlist6, setColorlist6] = useState(colorheader);
    const [colorlist7, setColorlist7] = useState(colorheader);
    //header ink
    const [colorall, setColorall] = useState({ colorheader: "", remark: "", typecolor: "", number: '' });
    const [colordetail, setColordetail] = useState({ inkname: "", formulate: "", kg1: "", kg2: "", colordetailId: "" })

    useEffect(() => {
        getColorhaeader(journalId)
        getjournalbyid(journalId)
    }, [])


    function getColorhaeader(journalId) {

        FetchApis.FethcGet(`/productcolor/getproductByjournal/${journalId}`).then((res) => {

            setJourColorHeader(res.data.data)
        })

    }

    function getjournalbyid(journalId) {
        FetchApis.FethcGet(`/journal/journalbyId/${journalId}`).then(res => {
            if (res) {
                setJournalhead(res.data.data)
            }

        })
    }

    return (
        <div>
         
            {jouranlheader.length>0&&<div style={{padding:10}}>
                <div style={{ width: '100%', fontSize: 12, fontWeight: '800' }}>
                    <table style={{ marginBottom: 5, border: '0.5' ,width:'100%',fontSize:14}}>
                        <th>
                            <td style={{flexDirection: 'column', justifyContent: 'center' ,width:'60%',padding:5}}>
                                <label style={{ fontWeight: 'bold', fontSize: 12 }}>TECHNICAL DATA SHEET PART ( B ) </label>
                                <label style={{ fontWeight: 'bold', fontSize: 12 }}>เอกสารหมีกผสม แนบท้าย Printing </label>
                            </td>
                            <td style={{width:'20%',padding:5}}>
                                <label style={{ marginLeft: 3 }}>Ref. MK. NO : {jouranlheader[0].tdscode}</label>
                            </td>
                            <td style={{width:'30%',padding:5}}>
                                <label style={{ marginLeft: 3 }}>Date : {jouranlheader[0].createdatetime}</label>
                            </td>
                        </th>
                    </table>
                    <div>
                        {JourColorHeader.map((item, i) => (
                            <div style={{width:'100%'}}>
                                <label style={{ fontWeight: 'bold', backgroundColor: '#e5e7e9' }}>{i + 1}.Color :{item.colorname}</label>
                                <Viewnewcolerprinting colorId={item.colorId} />
                                <label style={{ fontWeight: 'bold' }}>Remarks : {JourColorHeader[0].remark} </label>
                            </div>
                        ))
                        }

                    </div>
                </div>
            </div>}
            <hr></hr>
        </div>
    )
}

export default ViewColorlist